<template>
  <el-dialog :title="'【' + modelParam.task_id + '】' + modelParam.describe" center class="devOps-modelThir"
    :visible.sync="dialogVisible" width="80%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="分支" prop="branch">
        <el-select style="width:100%" v-model="form.branch" filterable placeholder="请输入">
          <el-option v-for="item in branchOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="runLoading" type="warning" @click="onSubmit('run')">开始REVIEW<i v-show="runLoading"
            class="el-icon-loading"></i></el-button>
        <el-button :disabled="skipLoading" type="warning" @click="onSubmit('skip')">跳过<i v-show="skipLoading"
            class="el-icon-loading"></i></el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi">查看历史</el-button>
        <el-button type="warning" @click="handleClose">返回</el-button>
      </el-form-item>
    </el-form>
    <TableOne v-if="tableDataOne.length" :tableData="tableDataOne" />
    <pre v-if="message" v-html="message" class="tips-message"></pre>
    <TableThir v-if="tableData.length" :codeSuccessTotal="codeSuccessTotal" :tableData="tableData" />
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceListStageOutputApi,
  postODUDADcreateApi
} from "@/server/tops/devOps";

import { TableOne, TableThir } from "../table/index";

export default {
  components: { TableOne, TableThir },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {},
      rules: {
         branch: [{ required: true, message: "请输入分支", trigger: "blur" }],
      },
      message: "",
      runLoading: false,
      skipLoading: false,
      tableData: [],
      tableDataOne: [],
      codeSuccessTotal: 0,
      branchs: [],
      branchOptions: [],
    };
  },
  async mounted() {
    await this.queryDevOpsSpaceListStageParmInfo();
    await this.queryDevOpsSpaceStageSelectmapApi();
  },
  methods: {
    async queryDevOpsSpaceStageSelectmapApi() {
      const { module_name = "" } = this.modelParam || {};
      const ret = await postODUDADcreateApi({
        module_name: module_name || "BACKEND",
        domain:this.form.domain
      });
      this.branchs = this.branchOptions = ret.branchs.map((item) => {
        return { value: `${item}`, label: `${item}` };
      });
    },
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          this.form = ret.data;
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      this.tableData = [];
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableDataOne = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      this.message = "";
      this.codeSuccessTotal = 0;
      this.tableData = [];
      action === "run" && (await this.queryActionRunSubmit("run"));
      action === "skip" && (await this.queryActionSkipSubmit("skip"));
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
          } = this.modelParam;
          const { branch = "" } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            branch,
          };
          this.runLoading = true;
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            if (ret.status === "success" && ret.data?.output?.commits?.length) {
              this.tableData = ret.data.output.commits.map((item, index) => {
                item.code === 0 && this.codeSuccessTotal++;
                const itm = item.discussions[0] || {};
                const { updated_at = "", author = { author }, body = "" } = itm;
                let new_updated_at = updated_at
                  ? this.$moment(updated_at).format("YYYY-MM-DD HH:mm:ss")
                  : "";
                let obj = {
                  short_id: item.short_id || "",
                  updated_at: new_updated_at,
                  name: author.name || "",
                  body,
                  title: item.title || "",
                };
                return obj;
              });
              if (ret.data.output.commits.length <= this.codeSuccessTotal) {
                this.$notify({
                  message: "REVIEW成功",
                  type: "success",
                });
              } else {
                this.$notify({
                  message: `REVIEW失败，${ret.data.output.commits.length}个提交，${this.codeSuccessTotal}个完成`,
                  type: "error",
                });
              }
            } else {
              this.$notify({
                message: "操作失败",
                type: "error",
              });
            }
          } catch (error) {
            this.$notify({
              message: error || "操作失败",
              type: "error",
            });
          } finally {
            this.runLoading = false;
            this.tableDataOne = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 跳过接口调用
    async queryActionSkipSubmit(action) {
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
        branch: "",
      };
      try {
        this.skipLoading = true;
        const ret = await postDevopsSpaceStageActionApi(param);
        this.$notify({
          message: ret.status === "success" ? "跳过成功" : "跳过失败",
          type: ret.status === "success" ? "success" : "error",
        });
        ret.status === "success"
          ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
          : (this.message = JSON.stringify(ret.data || "", null, 2));
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.skipLoading = false;
        this.tableDataOne = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 240px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelThir {
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>